import { UserFields } from './UserFields';

export default function getDataSources( endpoint ) {
	return {
		parameters:  endpoint.parameters,
		valueSource: [
			{
				name:  'Fixed value',
				value: 'fixedValue',
			}, {
				name:     'Custom Parameter',
				value:    'parameter',
				disabled: endpoint.parameters.length === 0
			},
			{
				name: 'Dynamic',
				value: 'dynamic'
			},
			{
				name: 'Request body',
				value: 'body'
			},
		],
    valueSourceSimple: [
      {
        name:  'Fixed value',
        value: 'fixedValue',
      }, {
        name:     'Custom Parameter',
        value:    'parameter',
        disabled: endpoint.parameters.length === 0
      },
    ],
		serializedTypes: [
			{
				name:  'Raw',
				value: 'default',
			},
			{
				name:  'JSON',
				value: 'json',
			},
			{
				name:  'Serialized',
				value: 'serialized',
			},
		],
		dynamicValues: [
			{
				name: 'Current user: id',
				value: 'current_user_id'
			},
			{
				name: 'Current user: login',
				value: 'current_user_login'
			},
			{
				name: 'Current user: email',
				value: 'current_user_email'
			},
			{
				name: 'Current user: first name',
				value: 'current_user_firstname'
			},
			{
				name: 'Current user: last name',
				value: 'current_user_lastname'
			},
			{
				name: 'Current user: display name',
				value: 'current_user_display_name'
			},
			{
				name: 'Date (YYYY-mm-dd)',
				value: 'current_date_date'
			},
			{
				name: 'Date (YYYY-mm-dd hh:mm:ss)',
				value: 'current_date_date_time'
			},
			{
				name: 'Date: current timestamp',
				value: 'current_date_timestamp'
			},
			{
				name: 'Day: current day (d)',
				value: 'current_date_day_d'
			},
			{
				name: 'Day: current day text (D)',
				value: 'current_date_day_text_D'
			},
			{
				name: 'Day (j)',
				value: 'current_date_day_month_without_zeros_j'
			},
			{
				name: 'Day (l)',
				value: 'current_date_week_text_l'
			},
			{
				name: 'Day (N)',
				value: 'current_date_week_numeric_N'
			},
			{
				name: 'Day (S)',
				value: 'current_date_day_ordinal_suffix_S'
			},
			{
				name: 'Day (w)',
				value: 'current_date_week_numeric_w'
			},
			{
				name: 'Day (z)',
				value: 'current_date_day_year_z'
			},

			{
				name: 'Week (W)',
				value: 'current_date_week_number_year'
			},

			{
				name: 'Month (F)',
				value: 'current_date_month_text_F'
			},
			{
				name: 'Month (m)',
				value: 'current_date_month_m'
			},
			{
				name: 'Month (M)',
				value: 'current_date_month_letters_M'
			},
			{
				name: 'Month (n)',
				value: 'current_date_month_numeric_n'
			},
			{
				name: 'Month (t)',
				value: 'current_date_month_days_t'
			},

			{
				name: 'Year (L)',
				value: 'current_date_year_L'
			},
			{
				name: 'Year (o)',
				value: 'current_date_year_o'
			},
			{
				name: 'Year (Y)',
				value: 'current_date_year_Y'
			},
			{
				name: 'Year (y)',
				value: 'current_date_year_y'
			},

			{
				name: 'Time (a)',
				value: 'current_date_time_a'
			},
			{
				name: 'Time (A)',
				value: 'current_date_time_A'
			},
			{
				name: 'Time (B)',
				value: 'current_date_time_B'
			},
			{
				name: 'Time (g)',
				value: 'current_date_time_g'
			},
			{
				name: 'Time (G)',
				value: 'current_date_time_G'
			},
			{
				name: 'Time (h)',
				value: 'current_date_time_h'
			},
			{
				name: 'Time (H)',
				value: 'current_date_time_H'
			},
			{
				name: 'Time (i)',
				value: 'current_date_time_i'
			},
			{
				name: 'Time (s)',
				value: 'current_date_time_s'
			},
			{
				name: 'Time (u)',
				value: 'current_date_time_u'
			},

			{
				name: 'Timezone (e)',
				value: 'current_date_timezone_e'
			},
			{
				name: 'Timezone (I)',
				value: 'current_date_timezone_I'
			},
			{
				name: 'Timezone (O)',
				value: 'current_date_timezone_O'
			},
			{
				name: 'Timezone (P)',
				value: 'current_date_timezone_P'
			},
			{
				name: 'Timezone (T)',
				value: 'current_date_timezone_T'
			},
			{
				name: 'Timezone (u)',
				value: 'current_date_timezone_u'
			},
		],
		yesNo: [
			{
				name: 'Yes',
				value: 'yes',
			},
			{
				name: 'No',
				value: 'no',
			}
		],
		queryGroups: endpoint.displayData[0].queryGroups.map(el => el.fields[0].value),
		statuses:    [
			{
				name:  'Publish',
				value: 'publish',
			},
			{
				name:  'Draft',
				value: 'draft',
			},
			{
				name:  'Future',
				value: 'future',
			},
			{
				name:  'Pending',
				value: 'pending',
			},
			{
				name:  'Private',
				value: 'private',
			},
			{
				name:  'Trash',
				value: 'trash',
			},
			{
				name:  'Auto-Draft',
				value: 'auto-draft',
			},
		],
		postTypes: restRoutesPostTypes,
		roles: restRoutesRoles,
		taxonomies: restRoutesTaxonomies,
		termFieldTypes: [
			{
				name:  'Term ID',
				value: 'term_id',
			},
			{
				name:  'Name',
				value: 'name',
			},
			{
				name:  'Slug',
				value: 'slug',
			},
		],
		userFieldColumns: [
			{
				name:  'ID',
				value: 'id',
			},
			{
				name:  'Name',
				value: 'name',
			},
			{
				name:  'User login',
				value: 'user_login',
			},
			{
				name:  'User password',
				value: 'user_pass',
			},
			{
				name:  'User nicename',
				value: 'user_nicename',
			},
			{
				name:  'User email',
				value: 'user_email',
			},
		],
		compareTypes: [
			{
				name:  'Equal to (=)',
				value: '=',
			},
			{
				name:  'Different (!=)',
				value: '!=',
			},
			{
				name:  'Less than (<)',
				value: '<',
			},
			{
				name:  'Greater than (>)',
				value: '>',
			},
			{
				name:  'Greater or equal than (>=)',
				value: '>=',
			},
			{
				name:  'Less or equal (<=)',
				value: '<=',
			},
			{
				name:  'Like',
				value: 'LIKE',
			},
			{
				name:  'Not like',
				value: 'NOT LIKE',
			},
			{
				name:  'IN',
				value: 'IN',
			},
			{
				name:  'Not in',
				value: 'NOT IN',
			},
			{
				name:  'Between',
				value: 'BETWEEN',
			},
			{
				name:  'Not between',
				value: 'NOT BETWEEN',
			},
			{
				name:  'Not exists',
				value: 'NOT EXISTS',
			},
			{
				name:  'REGEXP',
				value: 'REGEXP',
			},
			{
				name:  'NOT REGEXP',
				value: 'NOT REGEXP',
			},
			{
				name:  'RLIKE',
				value: 'RLIKE',
			},
		],
		compareTypesConditional: [
			{
				name:  'Equal to (=)',
				value: '=',
			},
			{
				name:  'Different (!=)',
				value: '!=',
			},
			{
				name:  'Less than (<)',
				value: '<',
			},
			{
				name:  'Greater than (>)',
				value: '>',
			},
			{
				name:  'Greater or equal than (>=)',
				value: '>=',
			},
			{
				name:  'Less or equal (<=)',
				value: '<=',
			},
			{
				name:  'Like (comma separated)',
				value: 'LIKE',
			},
			{
				name:  'Not like (comma separated)',
				value: 'NOT LIKE',
			},
			{
				name:  'IN (comma separated)',
				value: 'IN',
			},
			{
				name:  'Not in (comma separated)',
				value: 'NOT IN',
			},
		],
		compareTypesCustomTable: [
			{
				name:  'Equal to (=)',
				value: '=',
			},
			{
				name:  'Different (!=)',
				value: '<>',
			},
			{
				name:  'Less than (<)',
				value: '<',
			},
			{
				name:  'Greater than (>)',
				value: '>',
			},
			{
				name:  'Greater or equal than (>=)',
				value: '>=',
			},
			{
				name:  'Less or equal (<=)',
				value: '<=',
			},
			{
				name:  'Like',
				value: 'LIKE',
			},
			{
				name:  'Not like',
				value: 'NOT LIKE',
			},
			{
				name:  'In',
				value: 'IN',
			},
			{
				name:  'Not in',
				value: 'NOT IN',
			},
			{
				name:  'Between',
				value: 'BETWEEN',
			},
			{
				name:  'Not between',
				value: 'NOT BETWEEN',
			},
		],
		dataTypes: [
			{
				name:  'Numeric',
				value: 'NUMERIC',
			},
			{
				name:  'Binary',
				value: 'BINARY',
			},
			{
				name:  'Character',
				value: 'CHAR',
			},
			{
				name:  'Date',
				value: 'DATE',
			},
			{
				name:  'Date and time',
				value: 'DATETIME',
			},
			{
				name:  'Decimal',
				value: 'DECIMAL',
			},
			{
				name:  'Signed',
				value: 'SIGNED',
			},
			{
				name:  'Time',
				value: 'TIME',
			},
			{
				name:  'Unsigned',
				value: 'UNSIGNED',
			},
			{
				name:  'Numeric',
				value: 'NUMERIC',
			},
		],
		relationTypes: [
			{
				name:  'AND',
				value: 'AND',
			},
			{
				name:  'OR',
				value: 'OR',
			},
		],
		compareTypesTaxonomy: [
			{
				name:  'IN',
				value: 'IN',
			},
			{
				name:  'AND',
				value: 'AND',
			},
			{
				name:  'EXISTS',
				value: 'EXISTS',
			},
			{
				name:  'NOT EXISTS',
				value: 'NOT EXISTS',
			},
		],
		order: [
			{
				name:  'ASC',
				value: 'ASC',
			},
			{
				name:  'DESC',
				value: 'DESC',
			},
		],
		orderby: [
			{
				name:  'ID',
				value: 'ID',
			},
			{
				name:  'Author',
				value: 'author',
			},
			{
				name:  'Title',
				value: 'title',
			},
			{
				name:  'Name',
				value: 'name',
			},
			{
				name:  'Type',
				value: 'type',
			},
			{
				name:  'Date',
				value: 'date',
			},
			{
				name:  'modified',
				value: 'Modified',
			},
			{
				name:  'Parent',
				value: 'parent',
			},
			{
				name:  'Rand',
				value: 'rand',
			},
			{
				name:  'Comment count',
				value: 'comment_count',
			},
			{
				name:  'Relevance',
				value: 'relevance',
			},
			{
				name:  'Menu Order',
				value: 'menu_order',
			},
			{
				name:  'Custom Field',
				value: 'custom_field',
			},
		],
		orderByTaxonomy: [
			{
				name:  'Term ID',
				value: 'term_id',
			},
			{
				name:  'Name',
				value: 'name',
			},
			{
				name:  'Slug',
				value: 'slug',
			},
			{
				name:  'Count',
				value: 'count',
			},
			{
				name:  'Slug',
				value: 'slug',
			},
			{
				name:  'Parent',
				value: 'parent',
			},
			{
				name:  'Term taxonomy ID',
				value: 'term_taxonomy_id',
			},
		],
		methods: [
			'GET',
			'POST',
			'PUT',
			'PATCH',
			'DELETE',
		],
		orderByUsers: [...UserFields, {
			name:  'Custom Field',
			value: 'custom_field',
		}]
	}
}
